// Simple geocoding - matches common cities and countries to coordinates
const cityCoordinates = {
  // España - Ciudades
  'madrid': [40.4168, -3.7038],
  'barcelona': [41.3851, 2.1734],
  'valencia': [39.4699, -0.3763],
  'sevilla': [37.3891, -5.9845],
  'bilbao': [43.2627, -2.9253],
  'málaga': [36.7213, -4.4214],
  'malaga': [36.7213, -4.4214],
  'zaragoza': [41.6488, -0.8891],
  'murcia': [37.9922, -1.1307],
  'palma': [39.5696, 2.6502],
  'las palmas': [28.1248, -15.4300],
  'alicante': [38.3452, -0.4815],
  
  // Portugal - Ciudades
  'lisboa': [38.7223, -9.1393],
  'lisbon': [38.7223, -9.1393],
  'porto': [41.1579, -8.6291],
  'oporto': [41.1579, -8.6291],
  'braga': [41.5454, -8.4265],
  'coimbra': [40.2033, -8.4103],
  'faro': [37.0194, -7.9322],
  
  // América Latina - Argentina
  'buenos aires': [-34.6037, -58.3816],
  'córdoba': [-31.4201, -64.1888],
  'rosario': [-32.9442, -60.6505],
  'mendoza': [-32.8895, -68.8458],
  
  // América Latina - México
  'méxico': [19.4326, -99.1332],
  'mexico': [19.4326, -99.1332],
  'ciudad de méxico': [19.4326, -99.1332],
  'guadalajara': [20.6597, -103.3496],
  'monterrey': [25.6866, -100.3161],
  'cancún': [21.1619, -86.8515],
  'cancun': [21.1619, -86.8515],
  
  // América Latina - Colombia
  'bogotá': [4.7110, -74.0721],
  'bogota': [4.7110, -74.0721],
  'medellín': [6.2476, -75.5658],
  'medellin': [6.2476, -75.5658],
  'cali': [3.4516, -76.5320],
  'cartagena': [10.3910, -75.4794],
  
  // América Latina - Perú
  'lima': [-12.0464, -77.0428],
  'cusco': [-13.5319, -71.9675],
  'arequipa': [-16.4090, -71.5375],
  
  // América Latina - Chile
  'santiago': [-33.4489, -70.6693],
  'valparaíso': [-33.0472, -71.6127],
  'valparaiso': [-33.0472, -71.6127],
  
  // América Latina - Venezuela
  'caracas': [10.4806, -66.9036],
  'maracaibo': [10.6666, -71.6124],
  
  // América Latina - Brasil
  'são paulo': [-23.5505, -46.6333],
  'sao paulo': [-23.5505, -46.6333],
  'río de janeiro': [-22.9068, -43.1729],
  'rio de janeiro': [-22.9068, -43.1729],
  'brasilia': [-15.8267, -47.9218],
  'belo horizonte': [-19.9167, -43.9345],
  'salvador': [-12.9714, -38.5014],
  'recife': [-8.0476, -34.8770],
  
  // Europa - Francia
  'parís': [48.8566, 2.3522],
  'paris': [48.8566, 2.3522],
  'marsella': [43.2965, 5.3698],
  'lyon': [45.7640, 4.8357],
  'toulouse': [43.6047, 1.4442],
  
  // Europa - Italia
  'roma': [41.9028, 12.4964],
  'rome': [41.9028, 12.4964],
  'milán': [45.4642, 9.1900],
  'milan': [45.4642, 9.1900],
  'venecia': [45.4408, 12.3155],
  'venice': [45.4408, 12.3155],
  'florencia': [43.7696, 11.2558],
  'florence': [43.7696, 11.2558],
  
  // Europa - Alemania
  'berlín': [52.5200, 13.4050],
  'berlin': [52.5200, 13.4050],
  'múnich': [48.1351, 11.5820],
  'munich': [48.1351, 11.5820],
  'hamburgo': [53.5511, 9.9937],
  'fráncfort': [50.1109, 8.6821],
  'frankfurt': [50.1109, 8.6821],
  
  // Europa - Reino Unido
  'londres': [51.5074, -0.1278],
  'london': [51.5074, -0.1278],
  'manchester': [53.4808, -2.2426],
  'edimburgo': [55.9533, -3.1883],
  'edinburgh': [55.9533, -3.1883],
  
  // Europa - Países Bajos
  'ámsterdam': [52.3676, 4.9041],
  'amsterdam': [52.3676, 4.9041],
  'rotterdam': [51.9244, 4.4777],
  
  // América del Norte - USA
  'nueva york': [40.7128, -74.0060],
  'new york': [40.7128, -74.0060],
  'los ángeles': [34.0522, -118.2437],
  'los angeles': [34.0522, -118.2437],
  'miami': [25.7617, -80.1918],
  'chicago': [41.8781, -87.6298],
  'san francisco': [37.7749, -122.4194],
  'washington': [38.9072, -77.0369],
  'boston': [42.3601, -71.0589],
  
  // América del Norte - Canadá
  'toronto': [43.6532, -79.3832],
  'montreal': [45.5017, -73.5673],
  'vancouver': [49.2827, -123.1207],
  
  // Asia
  'tokio': [35.6762, 139.6503],
  'tokyo': [35.6762, 139.6503],
  'pekín': [39.9042, 116.4074],
  'beijing': [39.9042, 116.4074],
  'shanghái': [31.2304, 121.4737],
  'shanghai': [31.2304, 121.4737],
  'seúl': [37.5665, 126.9780],
  'seoul': [37.5665, 126.9780],
  'bangkok': [13.7563, 100.5018],
  'singapur': [1.3521, 103.8198],
  'singapore': [1.3521, 103.8198],
};

// Country coordinates (capital cities as default for each country)
const countryCoordinates = {
  // Europa
  'españa': [40.4168, -3.7038],
  'spain': [40.4168, -3.7038],
  'portugal': [38.7223, -9.1393],
  'francia': [48.8566, 2.3522],
  'france': [48.8566, 2.3522],
  'italia': [41.9028, 12.4964],
  'italy': [41.9028, 12.4964],
  'alemania': [52.5200, 13.4050],
  'germany': [52.5200, 13.4050],
  'reino unido': [51.5074, -0.1278],
  'united kingdom': [51.5074, -0.1278],
  'uk': [51.5074, -0.1278],
  'inglaterra': [51.5074, -0.1278],
  'england': [51.5074, -0.1278],
  'países bajos': [52.3676, 4.9041],
  'netherlands': [52.3676, 4.9041],
  'holanda': [52.3676, 4.9041],
  'bélgica': [50.8503, 4.3517],
  'belgium': [50.8503, 4.3517],
  'suiza': [46.9480, 7.4474],
  'switzerland': [46.9480, 7.4474],
  'austria': [48.2082, 16.3738],
  'grecia': [37.9838, 23.7275],
  'greece': [37.9838, 23.7275],
  
  // América Latina
  'argentina': [-34.6037, -58.3816],
  'méxico': [19.4326, -99.1332],
  'mexico': [19.4326, -99.1332],
  'colombia': [4.7110, -74.0721],
  'perú': [-12.0464, -77.0428],
  'peru': [-12.0464, -77.0428],
  'chile': [-33.4489, -70.6693],
  'venezuela': [10.4806, -66.9036],
  'brasil': [-15.8267, -47.9218],
  'brazil': [-15.8267, -47.9218],
  'ecuador': [-0.1807, -78.4678],
  'bolivia': [-16.5000, -68.1500],
  'paraguay': [-25.2637, -57.5759],
  'uruguay': [-34.9011, -56.1645],
  'costa rica': [9.9281, -84.0907],
  'panamá': [8.9824, -79.5199],
  'panama': [8.9824, -79.5199],
  
  // América del Norte
  'estados unidos': [38.9072, -77.0369],
  'united states': [38.9072, -77.0369],
  'usa': [38.9072, -77.0369],
  'eeuu': [38.9072, -77.0369],
  'canadá': [45.4215, -75.6972],
  'canada': [45.4215, -75.6972],
  
  // Asia
  'japón': [35.6762, 139.6503],
  'japan': [35.6762, 139.6503],
  'china': [39.9042, 116.4074],
  'corea del sur': [37.5665, 126.9780],
  'south korea': [37.5665, 126.9780],
  'india': [28.6139, 77.2090],
  'tailandia': [13.7563, 100.5018],
  'thailand': [13.7563, 100.5018],
  'filipinas': [14.5995, 120.9842],
  'philippines': [14.5995, 120.9842],
};

export const getCoordinatesFromLocation = (location) => {
  if (!location) return [40.4168, -3.7038]; // Default: Madrid
  
  const locationLower = location.toLowerCase();
  
  // Try to find city match first
  for (const [city, coords] of Object.entries(cityCoordinates)) {
    if (locationLower.includes(city)) {
      return coords;
    }
  }
  
  // If no city found, try to find country match
  for (const [country, coords] of Object.entries(countryCoordinates)) {
    if (locationLower.includes(country)) {
      return coords;
    }
  }
  
  // Default to Madrid, España if no match found
  return [40.4168, -3.7038];
};
